export default __webpack_public_path__ + "static/media/ic-scanner.896ec541.svg";